var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4ButtonsBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 140,
    viewBox: "0 0 1440 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.6961V140L361.254 103.302V0L0 36.6961Z",
    fill: "url(#paint0_linear_20816_111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361.254 36.6961V140L722.508 103.302V0L361.254 36.6961Z",
    fill: "url(#paint1_linear_20816_111)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.76 36.6961V140L1440 103.302V0L1083.76 36.6961Z",
    fill: "url(#paint2_linear_20816_111)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M728 36.6961V140L1089.25 103.302V0L728 36.6961Z",
    fill: "url(#paint3_linear_20816_111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20816_111",
    x1: 0,
    y1: 69.9992,
    x2: 361.254,
    y2: 69.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00123F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#081B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1D3360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#405A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F6B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20816_111",
    x1: 361.254,
    y1: 69.9992,
    x2: 722.508,
    y2: 69.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00123F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#081B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1D3360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#405A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F6B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20816_111",
    x1: 1083.76,
    y1: 69.9992,
    x2: 1440,
    y2: 69.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00123F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#081B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1D3360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#405A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F6B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20816_111",
    x1: 728,
    y1: 69.9992,
    x2: 1089.25,
    y2: 69.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00123F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#081B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1D3360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#405A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F6B99"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4ButtonsBg);
export default __webpack_public_path__ + "static/media/4buttonsBg.ce9814b5590a6ab4f57a0c27f2759ad3.svg";
export { ForwardRef as ReactComponent };